export default __webpack_public_path__ + "static/media/proj1_5.fdbb8ea1.jpg";